<template>
  <div class="corporate-culture">
    <div class="culture-canvas">
      <div class="canvas-box">
        <div class="por-container">
          <div class="icon">
            <img :src="require('@/assets/about/culture/arrow.png')" alt="" />
          </div>
          <div class="tit_zh">核心优势</div>
          <div class="tit_eh">CORE STRENGTHS</div>
          <div class="target">市场、产品、员工</div>
        </div>
        <div class="characteristic">
          <div class="target-item">
            <div class="target-tit">市场</div>
            <div class="target-txt">占有率高、口碑好</div>
          </div>
          <div class="target-item">
            <div class="target-tit">产品</div>
            <div class="target-txt">用户体验佳、产品创新快</div>
          </div>
          <div class="target-item">
            <div class="target-tit">员工</div>
            <div class="target-txt">稳定、幸福、成长</div>
          </div>
        </div>
      </div>
    </div>
    <div class="culture-details-wrap">
      <div class="culture-details">
        <div class="details-left">
          <div
            v-for="(item, index) in detailsList"
            :key="index"
            class="details-item"
            :class="{ 'isDetails': detailsIndex == index }"
            @mouseenter="onMouseEnter(index)"
          >
            <div class="gradient" :style="{opacity: detailsIndex != index ? 1 : 0}"></div>
            <div class="backg-img" :style="{opacity: detailsIndex == index ? 1 : 0}"></div>
            <div class="titZh">{{ item.titZh }}</div>
            <div class="titEh">{{ item.titEh }}</div>
            <div class="describe" :style="{opacity: detailsIndex == index ? 1 : 0}">
              <div
                v-for="(describeItem, describeIndex) in item.describe"
                :key="describeIndex"
                v-html="describeItem"
              >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getColumnChild } from '@/api/column';
import { getContentList, getContentDetail } from '@/api/content';
export default {
  name: 'CultureView',
  data () {
    return {
      detailsIndex: 0,
      detailsList: [
        // {
        //   titZh: '企业使命',
        //   titEh: 'CORPORATE MISSION',
        //   describe: '科技·让人力资源更智能',
        // },
        // {
        //   titZh: '企业愿景',
        //   titEh: 'CORPORATE VISION',
        //   describe: '成为全球领先HR知识共享平台',
        // },
        // {
        //   titZh: '企业价值观',
        //   titEh: 'CORPORATE VALUES',
        //   describe: '客户第一，员工第一，股东第二以客户为中心，以市场创值为驱动，以最大的价值回报给员工和股东',
        // },
        // {
        //   titZh: '企业核心',
        //   titEh: 'CORE STRENGTHS',
        //   describe: '市场占有率高、口碑好，产品用户体验佳、产品创新快，员工稳定、幸福、成长',
        // },
      ],
      titZh: '',
      titEh: '',
      txtLf: '',
      txtRt: '',
    };
  },
  mounted() {
    this.getPageColumn();
  },
  methods: {
    // 获取页面栏目
    async getPageColumn() {
      const params = { parentId: '1608278778444996608', };
      getColumnChild(params).then((res) => {
        const { result, } = res;
        for (var i = 0; i < result.length; i++) {
          if (result[i].name === '文化') {
            const data = { columnId: result[i].id, pageNum: 1, pageSize: 99, };
            getContentList(data).then(async (rrs) => {
              const rrsult = rrs.result;
              for (var j = 0; j < rrsult.data.length; j++) {
                var detailsItem = {
                  titZh: rrsult.data[j].title,
                  titEh: rrsult.data[j].summaryTitle,
                  describe: [],
                };
                const rts = await getContentDetail(rrsult.data[j].id);
                const rtsult = rts.result;

                for (var x = 0; x < rtsult.elements.length; x++) {
                  var doc = new DOMParser().parseFromString(rtsult.elements[x].content, 'text/html');
                  var describeItem = doc.documentElement.textContent.replace(/&nbsp;/g, ' ');
                  detailsItem.describe.push(describeItem);
                }
                this.detailsList.push(detailsItem);
              }
            });
          }
        }
      });
    },

    onMouseEnter(i) {
      this.detailsIndex = i;
    },
  },
};
</script>

<style lang="less" scoped>
.corporate-culture{
  width: 100%;
  min-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  .culture-canvas{
    width: 1200px;
    margin: 0 auto;
    padding: 30px 0;
    border-top: 2px solid #e8ecf3;
    box-sizing: border-box;
    .canvas-box{
      width: 100%;
      height: 440px;
      background: url('@/assets/about/culture/canvas.png') no-repeat;
      background-size: cover;
      background-position: center;
      display: flex;
      justify-content: flex-end;
      position: relative;
      .por-container{
        width: 540px;
        height: 100%;
        padding-top: 125px;
        box-sizing: border-box;
        .icon{
          height: 28px;
          margin-bottom: 10px;
          img{
            width: auto;
            height: 100%;
            display: block;
          }
        }
        .tit_zh{
          font-size: 16px;
          font-family: OPPOSans-B;
          color: #52525d;
          line-height: 1;
          letter-spacing: 3px;
          margin-bottom: 15px;
        }
        .tit_eh{
          font-size: 18px;
          font-family: OPPOSans-B;
          color: #b3c9e5;
          line-height: 1;
          margin-bottom: 19px;
        }
        .target{
          font-size: 24px;
          font-family: OPPOSans-M;
          color: #343538;
          line-height: 1;
        }
      }
      .characteristic{
        width: 600px;
        height: 440px;
        padding: 0 60px;
        padding-top: 133px;
        box-sizing: border-box;
        position: absolute;
        top: 0;
        right: 0;
        background: url('@/assets/about/culture/container-back.png') no-repeat;
        background-size: cover;
        background-position: center;
        opacity: 0;
        transition: opacity .3s ease-in-out;
        .target-item{
          margin-bottom: 24px;
          .target-tit{
            font-size: 16px;
            font-family: OPPOSans-R;
            color: #fff;
            line-height: 1;
            margin-bottom: 9px;
          }
          .target-txt{
            font-size: 16px;
            font-family: OPPOSans-R;
            color: #fff;
            line-height: 1;
          }
        }
      }
      &:hover{
        .characteristic{
          opacity: 1;
        }
      }
    }
  }
  .culture-details-wrap{
    width: 100%;
    height: 264px;
    background: url('@/assets/about/culture/culture-back.png') no-repeat;
    background-size: cover;
    background-position: center;
    padding: 22px 0;
    box-sizing: border-box;
    .culture-details{
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      background-color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .details-left{
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .details-item{
          flex: 1;
          height: 100%;
          transition: all .5s ease-in-out;
          padding: 45px 30px 0px;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          box-sizing: border-box;
          overflow: hidden;
          position: relative;
          .gradient{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 2;
            transition: opacity .5s ease-in-out;
          }
          .backg-img{
            width: 100%;
            height: 100%;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 1;
            transition: opacity .5s ease-in-out;
          }
          .titZh{
            font-size: 18px;
            font-family: OPPOSans-B;
            color: #fff;
            line-height: 1;
            margin-bottom: 10px;
            position: relative;
            z-index: 9;
            transition: all .5s ease-in-out;
          }
          .titEh{
            width: 105px;
            font-size: 16px;
            font-family: OPPOSans-B;
            color: #fff;
            line-height: 25px;
            position: relative;
            z-index: 9;
            // transition: all .5s ease-in-out;
            margin-bottom: 10px;
          }
          .describe{
            width: 340px;
            z-index: 9;
            font-size: 14px;
            font-family: OPPOSans-R;
            color: #4c5f64;
            transition: opacity .5s ease-in-out;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            // position: absolute;
            // top: 110px;
            >div{
              line-height: 24px;
            }
          }
          &:nth-child(1){
            .gradient{
              background-image: linear-gradient(90deg,
                  #7dd9f0 0%,
                  #39bcdd 100%),
                linear-gradient(
                  #c7c7cc,
                  #c7c7cc);
            }
            .backg-img{
              background-image: url('@/assets/about/culture/culture1.png');
            }
          }
          &:nth-child(2){
            .gradient{
              background-image: linear-gradient(90deg,
                  #b2daf3 0%,
                  #70b4d9 100%),
                linear-gradient(
                  #c7c7cc,
                  #c7c7cc);
            }
            .backg-img{
              background-image: url('@/assets/about/culture/culture2.png');
            }
          }
          &:nth-child(3){
            .gradient{
              background-image: linear-gradient(90deg,
                  #f0e1d5 0%,
                  #d3a78d 100%),
                linear-gradient(
                  #e5e5ea,
                  #e5e5ea );
            }
            .backg-img{
              background-image: url('@/assets/about/culture/culture3.png');
            }
          }
          &:nth-child(4){
            .gradient{
              background-image: linear-gradient(90deg,
                  #9fceff 0%,
                  #6ba2ff 100%),
                linear-gradient(
                  #c7c7cc,
                  #c7c7cc);
            }
            .backg-img{
              background-image: url('@/assets/about/culture/culture4.png');
            }
            .describe{
              flex-direction: row;
              justify-content: space-between;
              .target-item{
                margin-bottom: 6px;
              }
            }
          }
          &:nth-child(5){
            .gradient{
              background-image: linear-gradient(90deg,
                  #464a89 0%,
                  #4e52b5 100%),
                linear-gradient(
                  #e5e5ea,
                  #e5e5ea);
            }
            .backg-img{
              background-image: url('@/assets/about/culture/culture5.png');
            }
            .describe{
              flex-direction: row;
              justify-content: space-between;
            }
          }
        }
        .isDetails{
          flex: 2.5;
          .titZh{
            color: #00b0dc;
          }
          .titEh{
            width: 100%;
            color: #dfebff;
          }
        }
      }
      // .details-right{
      //   width: 410px;
      //   height: 100%;
      //   padding: 32px 30px;
      //   background: url('@/assets/about/culture/culture-right.png') no-repeat;
      //   background-size: cover;
      //   background-position: center;
      //   box-sizing: border-box;
      //   display: flex;
      //   flex-direction: column;
      //   justify-content: flex-end;
      //   align-items: flex-end;
      //   .tit-wrap{
      //     display: flex;
      //     flex-direction: column;
      //     align-items: flex-end;
      //     .tit-zh{
      //       font-size: 18px;
      //       font-family: OPPOSans-B;
      //       line-height: 1;
      //       color: #00b0dc;
      //       margin-bottom: 10px;
      //     }
      //     .tit-eh{
      //       font-size: 16px;
      //       font-family: OPPOSans-B;
      //       line-height: 1;
      //       color: #dfebff;
      //       margin-bottom: 24px;
      //     }
      //   }
      //   .txt-wrap{
      //     width: 100%;
      //     display: flex;
      //     justify-content: space-between;
      //     align-items: flex-start;
      //     .txt-lf{
      //       font-size: 16px;
      //       font-family: OPPOSans-R;
      //       font-size: 16px;
      //       color: #28619b;
      //       line-height: 25px;
      //     }
      //     .txt-rt{
      //       font-size: 16px;
      //       font-family: OPPOSans-R;
      //       font-size: 16px;
      //       color: #28619b;
      //       line-height: 25px;
      //     }
      //   }
      // }
    }
  }
}
</style>
